import {
  APPROVAL_ACTION_CONFIGURATION,
  APPROVAL_ACTION_CONFIGURATION_SUCCESS,
  APPROVAL_ACTION_CONFIGURATION_ERROR,
  APPROVAL_ACTION_CONFIGURATION_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApprovalActionConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_ACTION_CONFIGURATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_ACTION_CONFIGURATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_ACTION_CONFIGURATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVAL_ACTION_CONFIGURATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApprovalActionConfiguration;
